<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMeta } from '@/stores/meta.js'
import MultiSelect from '@/components/form/MultiSelect.vue'

/**
 * An address role's stand-ins (D-198), in order: the roles whose address it takes when no address
 * plays it, "*" being the first address. Edited by the dictionary's row; the other rows are the choices.
 */
const props = defineProps({ modelValue: { type: Array, default: () => [] }, row: { type: Object, default: null }, context: { type: Object, default: null }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
const meta = useMeta()
const { t } = useI18n()
const options = computed(() => [
  ...(props.context?.entries || []).filter((e) => e.key && e.key !== props.row?.key).map((e) => ({ value: e.key, label: meta.localized(e.label) || e.key })),
  { value: '*', label: t('dictionaries.firstAddress') },
])
</script>

<template>
  <MultiSelect :model-value="modelValue || []" :options="options" :disabled="disabled" @update:model-value="(v) => emit('update:modelValue', v)" />
</template>
